<template>
  <div class="w-full card mb-1">
    <b-card-header class="bg-white">
      <b-card-title>{{ title }}</b-card-title>
      <div class="text-center">
        <b-card-sub-title class="mb-25">
          Sipariş Toplam Tutar
        </b-card-sub-title>
        <b-card-title>{{ priceFormat(totalAmount) }} </b-card-title>
        <span v-html="subTitle"></span>
      </div>
      <div class="w-full dropdown-style d-flex">
        <div class="mt-1 mr-2"><b>{{ formatDate(rangeDate[0],false) }} - {{ formatDate(rangeDate[1]) }}</b></div>

        <div class="d-flex align-items-end">
          <!-- Range Select Option  -->
          <v-select
            :options="rangeOptions"
            v-model="rangeSelect"
            :reduce="val => val.value"
            class="w-auto fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary"
            placeholder="Tarih Aralığı"
            :clearable="false"
          />
          <!-- Flat-Pickr -->
          <div
            v-if="rangeSelect === 'custom'"
            class="d-flex align-items-center ml-1"
          >
            <feather-icon
              icon="CalendarIcon"
              size="20"
              @click="openDatePicker"
              class="cursor-pointer"
            />
            <!-- Burası hide -->
            <flat-pickr
              ref="flatPickrRef"
              v-model="rangePicker"
              :config="{ mode: 'range', dateFormat: 'Y-m-d',enableTime: false }"
              class="form-control flat-picker bg-transparent border-0 shadow-none hide"
            />
          </div>
        </div>
      </div>
      
    </b-card-header>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue';
import flatPickr from 'vue-flatpickr-component';
import ChartjsComponentHorizontalBarChart from '@components/charts-components/ChartjsComponentHorizontalBarChart.vue';
import chartjsData from '@/components/charts-components/chartjsData';
import vSelect from 'vue-select';

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    flatPickr,
    ChartjsComponentHorizontalBarChart,
    vSelect,
  },
  props: {
    title: {
      type: String,
    },
    totalAmount: {
      type: [String, Number], // Hem String hem Number kabul eder
      default: "Yükleniyor...",
    },
    subTitle: {
      type: String
    },
  },
  data() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    return {
      rangeOptions: [
        { label: 'Bu Ay', value: 'currentMonth' },
        { label: 'Geçen Ay', value: 'lastMonth' },
        { label: 'Son 3 Ay', value: 'last3Months' },
        { label: 'Özel Seçim', value: 'custom' },
      ],
      rangeSelect: 'currentMonth', // Varsayılan olarak bu ay
      rangeDate : [this.changeFormat(firstDayOfMonth), this.changeFormat(today)],
      rangePicker: this.changeFormat(firstDayOfMonth)+ ' to ' + this.changeFormat(today),
    };
  },
  methods: {
    // Tarihi 2024-11-04 formatına dönüştürme
    changeFormat(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Ay 2 basamaklı
      const day = String(date.getDate()).padStart(2, '0'); // Gün 2 basamaklı
      return `${year}-${month}-${day}`;
    },
    openDatePicker() {
      const flatpickrInstance = this.$refs.flatPickrRef.fp;
      flatpickrInstance.open();
    },
  },
  watch: {
    rangePicker(newValue) {
      if (this.rangeSelect === 'custom' && newValue.includes('to')) {
        const dates = newValue.split('to').map(date => date.trim()); // Tarihleri ayır ve gereksiz boşlukları kaldır
        if (dates.length === 2) { // Geçerli bir tarih aralığı olduğundan emin ol
          this.rangeDate = [dates[0], dates[1]];
          this.$emit('update-range',this.rangeDate)
        }
      }
    },
    rangeSelect(newValue) {
      const today = new Date();
      if (newValue === 'currentMonth') {
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        this.rangeDate = [
          this.changeFormat(startOfMonth),
          this.changeFormat(today),
        ];
      } else if (newValue === 'lastMonth') {
        const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        this.rangeDate = [
          this.changeFormat(startOfLastMonth),
          this.changeFormat(endOfLastMonth),
        ];
      } else if (newValue === 'last3Months') {
        const startOf3MonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, 1);
        this.rangeDate = [
          this.changeFormat(startOf3MonthsAgo),
          this.changeFormat(today),
        ];
      } else if (newValue === 'custom') {
        setTimeout(() => {
          this.openDatePicker();
        }, 200);
      }
      this.rangePicker = this.rangeDate[0] +' to '+ this.rangeDate[1];
      if (newValue !== 'custom') {
        this.$emit('update-range',this.rangeDate)
      }
    },
  },
};
</script>


<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .fixed-width {
    min-width: 230px; /* İhtiyaca göre genişliği ayarlayın */
    width: 100%;
  }
  .dropdown-style{
    .vs__dropdown-toggle{
      border:none; 
    }
    .vs__selected{
      color: var(--indigo) !important;
    }
    .dropdown-toggle::after{
      right: 10px;
      left: inherit;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .flat-picker.hide{
    width: 0;
    height: 0;
  }
</style>
